export const PRODUCT_TEMPLATE_AUTOCOMPLETE_MODEL = Object.freeze({
    validate: true,
    schemas: [
        {
            uri: "http://easas/product_template_schema_v1.json", // id of the first schema
            fileMatch: ["*"], // associate with our model
            schema: {
                type: "object",
                properties: {
                    attributes: {
                        type: "array",
                        title: "Template attributes",
                        items: { "$ref": "#/$defs/templateAttribute" },
                        default: [{referenceName: "reference_name", displayName: "Display Name", type: "INSTANT"}]
                    },
                    config: {
                        type: "object",
                        title: "General template settings",
                        $ref: "#/$defs/templateConfig"
                    },
                    parameterTemplates: {
                        type: "array",
                        title: "Parameter section templates",
                        items: { "$ref": "#/$defs/parameterTemplate" },
                    },
                },

                $defs: {
                    templateAttribute :{
                        type: "object",
                        valid: false,
                        properties: {
                            referenceName:{
                                type: "string",
                                description: "Unique table identifier",
                                default: "attribute_name"
                            },
                            displayName:{
                                type: "string",
                                description: "User friendly attribute name",
                                default: "Attribute name"
                            },
                            description:{
                                type: "string",
                                description: "Attribute description",
                                default: "Short description"
                            },
                            type:{
                                type: "string",
                                description: "Attribute data type",
                                enum: ["LONG", "DOUBLE", "STRING", "DATETIME", "INSTANT", "TIME", "TIMESPAN", "FOREIGN_KEY", "USER_SIGNATURE", "PARAMETERS", "MULTI_VALUE"]
                            },
                            subType: {
                                type: "string",
                                description: "Attribute sub type",
                                default: "STRING",
                                enum: ["LONG", "DOUBLE", "STRING", "TIME", "TIMESPAN"]
                            },
                            unit: {
                                type: "string",
                                description: "Data unit (for numerical)",
                                default: "KWh"
                            },
                            shortenText: {
                                type: "boolean",
                                description: "Use dialog for STRING attribute",
                                default: false
                            },
                            decimalPlaces: {
                                type: "integer",
                                description: "Number of decimal places to show (Only applies to decimal/double values)",
                                default: 2
                            },
                            defaultValue: {
                                type: "object",
                                description: "Default value for this attribute",
                                default: null
                            },
                            autoFillTime: {
                                type: "boolean",
                                description: "Auto fill date and/or time with current datetime on entry creation",
                                default: false
                            },
                            selectionValues: {
                                type: "array",
                                description: "Predefined selection values. Currently works only with STRING",
                                default: ["Selection 1", "Selection 2"]
                            },
                            locked: {
                                type: "boolean",
                                description: "If true nobody can edit column,it is update programmatically e.g. from Python script",
                                default: false,
                            },
                            requiredPermission: {
                                type: "string",
                                description: " Required permission to edit this column. If user does not have required permission, column will be locked",
                                default: "PRODUCT_TEMPLATE_ADMIN"
                            },
                            aggregationType: {
                                type: "string",
                                description: "Total row aggregation type",
                                enum: ["SUM", "MEAN", "COUNT"]
                            },
                            evaluationExpression: {
                                type: "string",
                                description: "Expression to calculate this column value",
                                default: "$some_attr1 + $some_attr3 * $some_attr_2"
                            },
                            dateDisplayPattern: {
                                type: "string",
                                description: "If the column type is Date, this field specifies how it is formatted",
                                default: "yyyy-MM-dd HH:mm"
                            },
                            foreignTemplate: {
                                type: "string",
                                description: "If the column type is FOREIGN_KEY, this field specifies the foreign table safe name",
                                default: "some_other_table_name"
                            },
                            bgHighlightRanges: {
                                type: "array",
                                description: "Highlight values according to ranges higher priority than highlightColor. Only works for LONG and DOUBLE attribute types",
                                default: [],
                                items: { "$ref": "#/$defs/highlightRange" },
                            },
                            highlightColor: {
                                type: "object",
                                description: "Highlight color for column.",
                                properties: {
                                    color: {
                                        type: "string",
                                        description: "Text color (CSS color)",
                                        default: "inherit"
                                    },
                                    bgColor: {
                                        type: "string",
                                        description: "Background color (CSS color)",
                                        default: "inherit"
                                    }
                                },
                                default: {
                                    color: "inherit",
                                    bgColor: "inherit"
                                },
                            },
                            appliedParameterTemplates: {
                                type: "array",
                                description: "List of parameter template sections applied to this column on entry creation",
                            },
                        },
                    },
                    templateConfig: {
                        type: "object",
                        properties: {
                            toStringFormatter: {
                                type: "string",
                                description: "Entry to string conversion. Use attribute prefixed with $. Predefined attributes #key, #meta, #start, #end",
                                default: "Batch No.#key of period #start - #end [$productType]"
                            },
                            startAttribute: {
                                type: "string",
                                description: "Attribute reference name which describes entry start moment",
                                default: "date_actual_start"
                            },
                            stopAttribute: {
                                type: "string",
                                description: "Attribute reference name describes entry end moment",
                                default: "date_actual_end"
                            },
                            rowsPerPage: {
                                type: "integer",
                                description: "Default rows per page",
                                default: 10
                            },
                            relations: {
                                type: "array",
                                description: "Describes template relation via attribute join",
                                default: [ {
                                    templateReference: "reference_to_other_table",
                                    joinAttributes: {
                                        thisTableAttr: "otherTableAttr",
                                        thisTableAttr3: "otherTableAttr6"
                                    }
                                }]
                            },
                            loadingType: {
                                type: "string",
                                description: "Template loading type",
                                enum: ["EVERYTHING", "FIXED_PERIOD", "RANGE"]
                            },
                            loadingConfig: {
                                type: "object",
                                description: "Template loading config",
                                $ref: "#/$defs/periodLoadingConfig"
                            },
                            sortingStrategy: {
                                type: "string",
                                description: "Sorting strategy of template",
                                enum: ["KEY_AND_META_KEY", "CREATION_DATE", "ADVANCED"],
                                default: "KEY_AND_META_KEY"
                            },
                            sortingStrategyOptions: {
                                type: "object",
                                description: "Sorting strategy options",
                                properties: {
                                    columns: {
                                        type: "array",
                                        description: "Columns to sort by",
                                        items: { "$ref": "#/$defs/columnSortOptions" },
                                    }
                                },
                                default: {
                                    "columns": [
                                        {
                                            "column": "col_ref",
                                        }
                                    ]
                                }
                            },
                            displayTotalRow: {
                                type: "boolean",
                                description: "Do display total row of table",
                                default: false
                            },
                            allowGenerateReport: {
                                type: "boolean",
                                description: "Allow generation email reports",
                                default: false
                            },
                            allowRowAddition: {
                                type: "boolean",
                                description: "Allow entry creation",
                                default: true
                            },
                            allowRowDeletion: {
                                type: "boolean",
                                description: "Allow row removal",
                                default: true
                            },
                            allowRowEdit: {
                                type: "boolean",
                                description: "Allow row modification",
                                default: true
                            },
                            timezoneId: {
                                type: "string",
                                description: "Timezone ID",
                                default: "Europe/Vilnius"
                            },
                        },
                    },
                    periodLoadingConfig: {
                        type: "object",
                        properties: {
                            truncateStartUnit: {
                                type: "string",
                                description: "Align start date to for loading time selection",
                                enum: ["MINUTES", "HOURS", "DAYS", "WEEKS", "MONTHS", "YEARS"]
                            },
                            periodUnit: {
                                type: "string",
                                description: "Time period unit for time loading types",
                                enum: ["MINUTES", "HOURS", "DAYS", "WEEKS", "MONTHS", "YEARS"]
                            },
                            period: {
                                type: "integer",
                                description: "Number of periods to load",
                                default: 1
                            },
                            offset: {
                                type: "integer",
                                description: "Offset of load window",
                                default: 1
                            },
                            offsetUnit: {
                                type: "string",
                                description: "Offset unit of load windows",
                                enum: ["MINUTES", "HOURS", "DAYS", "WEEKS", "MONTHS", "YEARS"]
                            },
                        },
                    },
                    parameterTemplate: {
                        type: "object",
                        properties: {
                            sectionTitle: {
                                type: "string",
                                description: "Section title",
                                default: "Title"
                            },
                            parameters: {
                                type: "array",
                                description: "Parameter definitions",
                                items: { "$ref": "#/$defs/parameterDefinition" },
                                default: [
                                    {
                                        "name": "param1",
                                        "type": "NUMBER",
                                        "options": {
                                            "defaultUnit": "rpm",
                                        }
                                    }
                                ]
                            },
                        },
                    },

                    parameterDefinition: {
                        type: "object",
                        properties: {
                            name: {
                                type: "string",
                                description: "Parameter name",
                                default: "param1"
                            },
                            type: {
                                type: "string",
                                description: "Parameter type",
                                enum: ["TEXT", "NUMBER", "LINK", "DATE", "FILE", "IMAGE", "MOMENT_NUMBER"],
                            },
                            options: {
                                type: "object",
                                description: "Parameter options",
                                properties: {
                                    defaultUnit: {
                                        type: "string",
                                        description: "Default unit for number parameter",
                                    }
                                }
                            }
                        }
                    },

                    highlightRange: {
                        type: "object",
                        description: "NUMBER or DOUBLE attribute highlight range",
                        properties: {
                            min: {
                                type: "object",
                                description: "Min value of range",
                                $ref: "#/$defs/highlightRangeValue"
                            },
                            max: {
                                type: "object",
                                description: "Max value of range",
                                $ref: "#/$defs/highlightRangeValue"
                            },
                            color: {
                                type: "string",
                                description: "Range text color (CSS color)",
                                default: "inherit"
                            },
                            bgColor: {
                                type: "string",
                                description: "Range background color (CSS color)",
                                default: "inherit"
                            }
                        }
                    },
                    highlightRangeValue: {
                        type: "object",
                        description: "Highlight range value",
                        properties: {
                            value: {
                                type: "number",
                                description: "Range value",
                                default: 0
                            },
                            inclusive: {
                                type: "boolean",
                                description: "Is range value inclusive",
                                default: false
                            }
                        }
                    },

                    columnSortOptions: {
                        type: "object",
                        description: "Column sort options",
                        properties: {
                            column: {
                                type: "string",
                                description: "Range value",
                                default: "col_ref"
                            },
                            order: {
                                type: "string",
                                enum: ["ASCENDING", "DESCENDING"],
                                description: "Is range value inclusive",
                                default: "DESCENDING"
                            }
                        }
                    }
                }
            }
        }
    ]
});